import deepmerge from 'deepmerge'
import type { MessageDescriptor } from 'react-intl'
import type { LoadableComponent } from '@loadable/component'
import { IconName, IconsProps } from '../../types/IconsType'

export type Locales = 'de-DE' | 'fr-CH' | 'de-CH' | 'de-AT'

export type Config = {
  tenantId: string
  cookiePrefix: string
  gtmDomain: string
  defaultLocale: Locales
  title?: string
  phonePREFIX?: string
  API_ERROR_MESSAGE?: MessageDescriptor
  theme: themeConfig
  info: InfoConfig
  ssr: SSRConfig
}

export type SSRConfig = {
  googleMapsAPIKey?: string
  serviceCloudKeys?: {
    contactFormKey?: string
    contactFormSubmitURL?: string
  }
}

export type InfoConfig = {
  email?: string
  tel?: string
  brand?: string
  organization?: string
  url?: string
  logo?: string
  team?: string
  supportEmail?: string
}

export type FontConfig = {
  regular?: string
  medium?: string
  bold?: string
  wide?: string
}

export type ButtonlayoutColorsType = {
  default?: string
  outline?: string
  danger?: string
  square?: string
}

type themeConfig = {
  iconMapping?: {
    [key in IconName]?: (
      props: IconsProps
    ) => JSX.Element | LoadableComponent<any>
  }
  font: FontConfig
  fontVariant: FontConfig
  mspComponents?: {
    input?: {
      default: { [prop: string]: string }
      underline: { [prop: string]: string }
      textColor?: string
    }
    button?: {
      [prop: string]: ButtonlayoutColorsType & {
        getColors?: (darkMode: boolean) => ButtonlayoutColorsType
      }
    }
    checkbox?: {
      getStyles?: (darkMode: boolean) => {
        labelStyle?: string
        enabledCheckStyle?: string
        disabledCheckStyle?: string
        valueTrueStyle?: string
        valueFalseStyle?: string
      }
    }
    radiobutton?: {
      getStyles?: (darkMode: boolean) => {
        label?: string
        labelWrapper?: string
        initial?: string
        checked?: string
        disabled?: string
      }
    }
    spinner?: {
      position?: string
      fullscreenContainer?: {
        dark?: string
        light?: string
      }
      animation?: {
        dark?: string
        light?: string
      }
      label?: {
        dark?: string
        light?: string
      }
      content?: JSX.Element
    }
    requestPasswordModal?: {
      header?: string
      detail?: string
    }
    loginForm?: { tracking: string; fontSize: string }
    accountDataSharing?: string
    headlineSubline?: string
    footerCheckout?: string
    footer?: {
      link?: string
      gridWrapperStyles?: string
      priceInfoWrapper?: string
      icon?: string
      iconWidth?: string
    }
    pageActionPlaceHolder?: {
      Wrapper?: string
      IconWrapper?: string
      Headline?: string
      ContentText?: string
      ActionsWrapper?: string
    }
    wishlistButton?: string
    headlineFont?: string
    newsletterForm?: string
    newsletterModal?: {
      title?: string
      success?: string
    }
    contactForm?: {
      reasonFieldName: string
      reasons: { id: string; value: MessageDescriptor }[]
    }
  }
}

export const getConfig = (
  defaultConfig: Partial<Config>,
  config: Partial<Config>
): Config => deepmerge<Config>(defaultConfig, config)

export default getConfig
